/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// Data
import { CambiarContrasena } from "store/usuarios/usuariosActions";

import { Button, Divider, Grid, Icon } from "@mui/material";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import ModalContent from "components/ModalContent";
import { store } from "store/store";
import { InformacionInicialRoles } from "store/roles/rolesActions";
import FormUsuario from "../formUsuario";
import Contrasena from "./cambiarContrasena";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Loading from "components/loading";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";

function VerUsuario() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { isloadingRoles } = useSelector((state) => state.roles);
  const usuario = store.getState().login.usuario;
  const dispatch = useDispatch();
  useEffect(() => {
    InformacionInicialRoles(dispatch);
  }, []);

  //Form nueva iamgen
  const [passwordActual, setpasswordActual] = useState("");
  const [password, setpassword] = useState("");
  const [confirmpassword, setconfirmpassword] = useState("");

  const [openmodal, setopenmodal] = useState(false);

  const handleGuardar = async () => {
    if (!passwordActual) {
      toast.error("Ingresa la contraseña actual");
      return false;
    }
    if (!password) {
      toast.error("Ingresa una contraseña nueva");
      return false;
    }
    if (!confirmpassword) {
      toast.error("Ingresa la confirmación de la contraseña nueva");
      return false;
    }
    if (password != confirmpassword) {
      toast.error("Las contraseñas no coinciden");
      return false;
    }

    var data = {
      username: "cayetanor",
      passwordActual: passwordActual,
      passwordNueva: password,
    };

    const exito = await dispatch(CambiarContrasena(data));
    if (exito) {
      refresh();
    }
  };

  const refresh = () => {
    setpasswordActual("");
    setpassword("");
    setconfirmpassword("");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid item xs={12} md={12} lg={12}>
        <MDBox mb={1.5} py={1} px={2} display="flex" justifyContent="space-between">
          <Button
            variant="contained"
            startIcon={<Icon>arrow_back_ios_new</Icon>}
            color="primary"
            size="small"
            style={{ textTransform: "inherit" }}
            onClick={() => navigate(state?.ruta)}
          >
            Regresar
          </Button>
        </MDBox>
      </Grid>
      {isloadingRoles ? (
        <Loading title={"Cargando datos del perfil, por favor espere"} />
      ) : (
        <Grid container spacing={5}>
          <Grid item xs={12} md={6}>
            <MDTypography variant="h6" color="white" sx={{ marginLeft: "15px" }}>
              DATOS DEL USUARIO
            </MDTypography>
            <Divider />
            <FormUsuario
              vista={"perfil"}
              props={{
                nombre: usuario?.nombre,
                apellioPaterno: usuario?.apellioPaterno,
                apellioMaterno: usuario?.apellioMaterno,
                rolUsuario: {
                  idRolUsuario: usuario?.idRolUsuario,
                  rolUsuario: usuario?.rolUsuario,
                },
                hospital: { idHospital: usuario?.hospital },
                correo: usuario?.correo,
                celular: usuario?.celular,
                username: usuario?.username,
              }}
              invalids={{
                invalid_nombre: false,
                invalid_apellioPaterno: false,
                invalid_apellioMaterno: false,
                invalid_rolUsuario: false,
                invalid_hospital: false,
                invalid_correo: false,
                invalid_celular: false,
                invalid_username: false,
                invalid_password: false,
                invalid_confirmpassword: false,
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <MDTypography variant="h6" color="white" sx={{ marginLeft: "15px" }}>
              CAMBIAR CONTRASEÑA
            </MDTypography>
            <Divider />
            <Contrasena
              props={{
                password: password,
                confirmpassword: confirmpassword,
                passwordActual: passwordActual,
              }}
              onChangeUser={(value, campo) => {
                if (campo === "passwordActual") setpasswordActual(value);
                if (campo === "password") setpassword(value);
                if (campo === "confirmpassword") setconfirmpassword(value);
              }}
              onClickGuardar={() => handleGuardar()}
              onClickCancelar={() => refresh()}
            />
          </Grid>
        </Grid>
      )}

      <ModalContent
        title={"Cambio de contraseña"}
        maxWidth="sm"
        fullWidth={false}
        open={openmodal}
        fullScreen={false}
        handleClose={() => {
          setopenmodal(false);
          refresh();
        }}
        handleAcept={() => {
          var data = {
            idGaleria: galeriaEliminar.idGaleria,
            rutaArchivo: galeriaEliminar.rutaDescargar,
          };
          //CambiarContraseña(dispatch, data);
          setopenmodal(false);
        }}
        textAccept={"Cambiar contraseña"}
      >
        <MDBox>
          <MDTypography variant="button" color="text" fontWeight="regular">
            ¿Desea cambiar su contraseña?
          </MDTypography>
        </MDBox>
      </ModalContent>
      <Footer />
    </DashboardLayout>
  );
}

export default VerUsuario;
